import React, { Component } from 'react';
import Select from 'react-select';
import { Translate } from 'react-redux-i18n';

export class TaxSelectionModal extends Component {
  render() {
    return (
      <div>
        <label><Translate value="tax_rate" /></label>
        <Select
          options={this.props.taxRateOptions}
          value={this.props.taxValue}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default TaxSelectionModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/taxSelectionModal.jsx